import { render, staticRenderFns } from "./AtomSwitchLabel.vue?vue&type=template&id=d32cb95a&"
import script from "./AtomSwitchLabel.vue?vue&type=script&lang=js&"
export * from "./AtomSwitchLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports